var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9925 11.2075L0.100525 4.77588V17.5551C0.10229 18.203 0.360436 18.8238 0.818548 19.2819C1.27666 19.74 1.89749 19.9981 2.54535 19.9999H23.4511C24.0989 19.9981 24.7197 19.74 25.1779 19.2819C25.636 18.8238 25.8941 18.203 25.8959 17.5551V4.91059L12.9925 11.2075Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0039 8.79239L25.8959 2.50024V2.44483C25.8941 1.79696 25.636 1.17613 25.1779 0.718023C24.7197 0.259911 24.0989 0.00176497 23.4511 0H2.54535C1.91239 0.0012555 1.30444 0.247283 0.848748 0.686591C0.393057 1.1259 0.124944 1.72444 0.100525 2.35693L13.0039 8.79239Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.56a57201bf5414874cd571953bc6c85b.svg";
export { ForwardRef as ReactComponent };